jQuery(document).ready(function($) {
    reload_timepickers();
});
jQuery(document).ajaxComplete(function($) {
    if(window.timepickerwaiter) {
        clearTimeout(window.timepickerwaiter);
    }
    window.timepickerwaiter = setTimeout(function() {
        reload_timepickers();
    },100);
});
function reload_timepickers() {
    var $ = jQuery.noConflict();

    var maxZ = Math.max.apply(null,
        $.map($('.reveal'), function(e,n) {
            if ($(e).css('position') != 'static')
                return parseInt($(e).css('z-index')) || 1;
        }));


    $('[data-timepicker]:not(.hasTimepicker)').each(function() {
        var elm = $(this);
        elm.addClass('hasTimepicker');

        //Open the timepopup when asked
        elm.focus(function() {
            elm = $(this);
            let picker = $('.timepicker-wrapper');
            if(picker.length > 0) {
                picker.remove();
            }

            $('body').append('<div class="timepicker-wrapper">' +
                '<input type="text" id="timepicker-H" />' +
                '<span>:</span>' +
                '<input type="text" id="timepicker-m" />' +
                '</div>');
            picker = $('.timepicker-wrapper:first');

            picker.css({
                'z-index': maxZ,
                'left': elm.offset().left,
                'top': elm.offset().top,
                'opacity': 1
            });
            picker.find('#timepicker-H').val(elm.val().split(':')[0]);
            picker.find('#timepicker-m').val(elm.val().split(':')[1]);
            picker.find('#timepicker-H').select().focus();
            picker.find('input').keydown(function(e) {
                if(e.keyCode == 13) {
                    $(this).blur();
                }
            }).blur(function() {
                var H = parseInt(picker.find('#timepicker-H').val());
                var m = parseInt(picker.find('#timepicker-m').val());
                var leadZero = function(no) { return no < 10 ? '0'+no : no};
                //elm.val(leadZero(H)+":"+leadZero(m)).trigger('change.textUpdate');
                const value = elm.val();
                const newValue = leadZero(H)+":"+leadZero(m);
                if (value !== newValue) {
                    elm.val(newValue).trigger('change');
                }
                elm.blur();
            }.bind([elm, picker]));
        }).blur(function() {
            elm = $(this);
            setTimeout(function() {
                var focused = $(':focus');
                if(focused.attr('id') != 'timepicker-H' && focused.attr('id') != 'timepicker-m') {
                    $('.timepicker-wrapper').fadeOut(500,function() {
                        $(this).remove();
                    });
                }
            }.bind([elm]),50);
        });

        //Use a link as opener
        var prev = $(this).prev();
        if(prev.is('[data-open-timepicker]')) {
            elm.css({
                'opacity': 0,
                'height': 0,
                'line-height': 0,
                'margin': 0,
                'padding': 0,
                'width': 0,
                'display': 'inline'
            });
            prev.click(function(e) {
                e.preventDefault();
                //elm.focus();
                $(this).next().focus();
            //}.bind([elm]));
            });

            elm.bind('change.textUpdate',function() {
                //prev.html(elm.val());
                $(this).prev().html($(this).val());
            //}.bind([prev, elm]));
            });
        }

    });
}
